import React from "react";
import PropTypes from "prop-types";
import _ from "lodash";

const Highcharts = window.Highcharts;
const HighchartsReact = window.HighchartsReact;

import {
  sharedChartOptions,
  legendOptions,
  tooltipOptions,
  columnPlotOptions,
  seriesOptions
} from "./chartOptions";

class DigitalIndustrialForecast extends React.Component {
  constructor(props) {
    super(props);

    const spendingByCategoryData = _.map(props.data.digital_spending_by_category_data, (value) => {
      return {
        name: value[0],
        data: _.values(value[1]),
        color: seriesOptions.find(col => col.name == value[0]).color
      };
    }).reverse();

    const spendingByParameterData = _.map(props.data.digital_spending_by_parameter_data, (value) => {
      return {
        name: value[0],
        data: _.values(value[1]),
        color: seriesOptions.find(col => col.name == value[0]).color
      };
    });

    const spendingBySensorsData = _.map(props.data.digital_spending_by_parameter_sensors_data, (value) => {
      return {
        name: value[0],
        data: _.values(value[1]),
        color: seriesOptions.find(col => col.name == value[0]).color
      };
    });

    const pointStart = () => Number(Object.keys(props.data.digital_spending_by_parameter_data[0][1])[0]);

    const columnPlotOptionsWithStart = () => ({ series: { ...columnPlotOptions.series, ...{ pointStart: pointStart() } } });

    this.state = {
      categoryChartOptions: {
        chart: {
          type: "column",
          height: 850,
          width: 420,
          className: `${props.data.chart_class_name}-triple-chart`
        },
        ...sharedChartOptions,
        title: {
          text: "Total spending by category",
          style: {
            fontWeight: "bold",
            fontSize: "16px"
          }
        },
        legend: {
          ...legendOptions
        },
        plotOptions: {
          series: {
            pointStart: pointStart(),
            point: {
              events: {
                mouseOver: () => this.setCategoryChartHoverState("param"),
                mouseOut: () => this.resetCategoryChartHoverState()
              }
            }
          },
          ...columnPlotOptionsWithStart(),
        },
        tooltip: {
          ...tooltipOptions
        },
        series: spendingByCategoryData
      },
      parameterChartOptions: {
        chart: {
          type: "line",
          height: 400,
          width: 420,
        },
        ...sharedChartOptions,
        title: {
          text: "Total spending by type of parameter",
          style: {
            fontWeight: "bold",
            fontSize: "16px"
          }
        },
        legend: {
          ...legendOptions
        },
        plotOptions: {
          series: {
            pointStart: pointStart(),
            point: {
              events: {
                mouseOver: () => this.setCategoryChartHoverState("param"),
                mouseOut: () => this.resetCategoryChartHoverState()
              }
            },
            marker: {
              enabled: false,
              symbol: "circle"
            },
            animation: false,
          },
        },
        tooltip: {
          ...tooltipOptions
        },
        series: spendingByParameterData,
      },
      sensorChartOptions: {
        chart: {
          type: "column",
          height: 400,
          width: 420,
        },
        ...sharedChartOptions,
        title: {
          text: undefined
        },
        legend: {
          ...legendOptions
        },
        plotOptions: {
          ...columnPlotOptionsWithStart(),
        },
        tooltip: {
          ...tooltipOptions
        },
        series: spendingBySensorsData
      }
    };

    this.setCategoryChartHoverState = this.setCategoryChartHoverState.bind(this);
    this.resetCategoryChartHoverState = this.resetCategoryChartHoverState.bind(this);
  }

  setCategoryChartHoverState(fromChart) {
    const categoryChart = window.Highcharts.charts.find(chart => chart.options.chart.className === this.state.categoryChartOptions.chart.className);
    if (fromChart === "param") {
      categoryChart.series[0].points.forEach(point => point.setState("inactive"));
      categoryChart.series[1].points.forEach(point => point.setState("inactive"));
    } else if (fromChart === "sensors") {
      categoryChart.series[0].points.forEach(point => point.setState("inactive"));
      categoryChart.series[1].points.forEach(point => point.setState("inactive"));
      categoryChart.series[2].points.forEach(point => point.setState("inactive"));
      categoryChart.series[3].points.forEach(point => point.setState("inactive"));
    }
  }

  resetCategoryChartHoverState() {
    const categoryChart = window.Highcharts.charts.find(chart => chart.options.chart.className === this.state.categoryChartOptions.chart.className);
    categoryChart.series.forEach(series => series.points.forEach(point => point.setState("normal")));
  }

  render() {
    const { parameterChartOptions, categoryChartOptions, sensorChartOptions } = this.state;

    return (
      <div id="digital-industrial-forecast-triple">
        <div id="spending-by-category">
          <HighchartsReact
            highcharts={Highcharts}
            constructorType={"chart"}
            options={categoryChartOptions}
          />
        </div>
        <div id="parameter-sensors-column">
          <div id="spending-by-parameter">
            <HighchartsReact
              highcharts={Highcharts}
              constructorType={"chart"}
              options={parameterChartOptions}
            />
          </div>
          <div id="spending-by-sensors">
            <div id="sensor-chart-title">
              Total spending by water quality sensors
            </div>
            <div
              id="sensor-chart-container"
              onMouseEnter={() => this.setCategoryChartHoverState("sensors")}
              onMouseLeave={() => this.resetCategoryChartHoverState()}
            >
              <HighchartsReact
                highcharts={Highcharts}
                constructorType={"chart"}
                options={sensorChartOptions}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DigitalIndustrialForecast.propTypes = {
  data: PropTypes.shape(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.any)).isRequired).isRequired,
};

export default DigitalIndustrialForecast;
